import { GridApi } from '@ag-grid-community/core';
import { TAX_ITEMS_SORT_MAPPINGS } from '../constants';
import { SortMode } from '../types';

type OriginalSortModel = ReturnType<GridApi['getSortModel']>;
type FixedSortModel = Omit<OriginalSortModel[number], 'sort'> & {
  // Rather than string | null | undefined
  sort: 'asc' | 'desc' | null | undefined;
};

export function sortModelToMode(sortModel: FixedSortModel[]): SortMode | null {
  if (sortModel.length == 0) {
    return null;
  }

  const firstColumn = sortModel[0];
  if (!firstColumn.colId || !firstColumn.sort) {
    return null;
  }

  const columnMapping = TAX_ITEMS_SORT_MAPPINGS[firstColumn.colId];
  if (!columnMapping) {
    return null;
  }

  return columnMapping[firstColumn.sort];
}
